import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-icon-del',
  templateUrl: './btn-icon-del.component.html',
  styleUrls: ['./btn-icon-del.component.css']
})
export class BtnIconDelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
